/* ZOMKI · Percheros: las prendas se cuelgan en percha; accesorios, packs y hogar se muestran como producto, sin percha. */
(function () {
  'use strict';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency });
  function money(cents) { return fmt.format(cents / 100); }
  function cents(v) { return typeof v === 'number' ? v : Math.round(parseFloat(v) * 100); }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HOOK = '<svg class="zr-hook" viewBox="0 0 120 60" aria-hidden="true"><path d="M60 4c-7 0-11 5-11 10 0 6 5 8 11 11v8M60 33 10 56h100z" fill="none" stroke="#c9c2c7" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"/></svg>';

  // Estilos de los productos que no son prendas: tarjeta limpia sobre balda, sin gancho ni barra.
  (function () {
    if (document.getElementById('zr-shelf-css')) return;
    var st = document.createElement('style');
    st.id = 'zr-shelf-css';
    st.textContent =
      '.zr-item--shelf .zr-swing{transform:none!important}' +
      '.zr-item--shelf .zr-frame{margin-top:30px;border-radius:14px}' +
      '.zr-item--shelf .zr-card{object-fit:contain;padding:7%;background:#fff}' +
      '.zr--shelf .zr-rod{display:none}' +
      '.zr--shelf .zr-item--shelf .zr-frame{margin-top:8px}' +
      '.zr--shelf .zr-stage::after{content:"";position:absolute;left:0;right:0;bottom:28%;height:0}' +
      '.zr-item--shelf .zr-badge--kind{top:auto;bottom:8px;left:8px;background:#fff;color:#0f0e10;border:1px solid rgb(15 14 16 / .15)}';
    document.head.appendChild(st);
  })();

  function sized(src, w) {
    if (!src) return '';
    return src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  // Imagen para colgar: la foto plana de la prenda (Printful/Printify) si existe; si no, la foto con modelo.
  function isFlat(src) {
    var f = String(src || '').toLowerCase().split('?')[0].split('/').pop();
    if (/_preview|modelo|portada|frontal|model|lifestyle|catalogo|editorial/.test(f)) return false;
    return /-front[-.]|flat|_2048|mockup/.test(f);
  }
  function hangerImage(p) {
    var imgs = p.images || [];
    for (var i = 0; i < imgs.length; i++) if (isFlat(imgs[i].src)) return { src: imgs[i].src, flat: true };
    return imgs.length ? { src: imgs[0].src, flat: false } : null;
  }
  function shortName(t) {
    return String(t || '').split('·')[0].split('|')[0].split('—')[0].replace(/^ZOMKI\s+/i, '').trim();
  }
  function priceLabel(p) {
    var prices = p.variants.map(function (v) { return cents(v.price); });
    var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
    return (min !== max ? 'Desde ' : '') + money(min);
  }
  function isSet(p) {
    return (p.tags || []).some(function (t) { return /^conjunto/i.test(t); }) || /^conjunto/i.test(p.title);
  }
  function isShelf(p) { return p && p.g === false; }
  function kindLabel(p) {
    return /^(pack|kit)\b/i.test(p.t || '') ? 'Pack' : '';
  }

  function Rack(el) {
    this.el = el;
    this.track = el.querySelector('[data-zr-track]');
    this.quick = el.querySelector('[data-zr-quick]');
    this.cache = {};
    this.items = [];
    this.products = [];
    this.index = 0;
    this.limit = Number(el.dataset.limit) || 24;
    var self = this;

    el.querySelectorAll('[data-zr-tab]').forEach(function (b) {
      b.addEventListener('click', function () { self.load(b); });
    });
    el.querySelectorAll('[data-zr-step]').forEach(function (b) {
      b.addEventListener('click', function () { self.select(self.index + Number(b.dataset.zrStep), true); });
    });
    el.querySelector('[data-zr-open]').addEventListener('click', function () {
      var a = self.items[self.index] && self.items[self.index].querySelector('a');
      if (a) a.click();
    });
    this.bindTrack();
    this.bindQuick();

    var first = el.querySelector('.zr-tab[aria-pressed="true"]') || el.querySelector('[data-zr-tab]');
    // Arriba de la página se carga al momento; más abajo, cuando se acerca (con respaldo al terminar de cargar la página).
    var started = false;
    function start() { if (started) return; started = true; self.load(first); }
    if (el.getBoundingClientRect().top < window.innerHeight * 1.5 || !('IntersectionObserver' in window)) start();
    else {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { io.disconnect(); start(); }
      }, { rootMargin: '600px' });
      io.observe(el);
      var later = function () { setTimeout(start, 2500); };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
    }
  }

  Rack.prototype.load = function (tab) {
    if (!tab) return;
    var self = this, handle = tab.dataset.zrTab;
    this.el.querySelectorAll('[data-zr-tab]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === tab)); });
    var all = this.el.querySelector('[data-zr-all]');
    if (all && tab.dataset.url && all.getAttribute('href').charAt(0) !== '#') all.href = tab.dataset.url;
    this.track.setAttribute('aria-busy', 'true');
    // Datos calculados por Shopify (precio, rebaja, ahorro real de cada conjunto, foto plana o con modelo).
    var job = this.cache[handle] ? Promise.resolve(this.cache[handle]) :
      fetch(ROOT + 'collections/' + encodeURIComponent(handle) + '?section_id=zomki-percheros-data', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('[data-zr-data]');
          var list = JSON.parse(node ? node.textContent : '[]').filter(function (p) { return p.flat || p.img; }).slice(0, self.limit);
          self.cache[handle] = list;
          return list;
        });
    job.then(function (list) { self.render(list, handle); })
      .catch(function () {
        self.track.innerHTML = '<li class="zr-empty">No hemos podido cargar este perchero. <a href="' + esc(tab.dataset.url || '/collections/all') + '">Ver los productos</a></li>';
      })
      .then(function () { self.track.setAttribute('aria-busy', 'false'); });
  };

  Rack.prototype.render = function (list, handle) {
    var self = this;
    this.products = list;
    this.track.innerHTML = '';
    var shelfCount = 0;
    list.forEach(function (p, i) {
      var shelf = isShelf(p);
      if (shelf) shelfCount++;
      var li = document.createElement('li');
      li.className = 'zr-item' + (shelf ? ' zr-item--shelf' : '');
      var src = shelf ? (p.img || p.flat) : (p.flat || p.img);
      var price = (p.v ? 'Desde ' : '') + money(p.p);
      var save = p.set && p.sep > p.p ? p.sep - p.p : 0;
      var off = p.ca > p.p ? Math.round((1 - p.p / p.ca) * 100) : 0;
      var badge = save ? '<span class="zr-badge zr-badge--save">Conjunto · ahorras ' + esc(money(save)) + '</span>' :
        (off ? '<span class="zr-badge zr-badge--off">-' + off + ' %</span>' : (p.set ? '<span class="zr-badge">Conjunto</span>' : ''));
      var kind = shelf ? kindLabel(p) : '';
      if (kind) badge += '<span class="zr-badge zr-badge--kind">' + esc(kind) + '</span>';
      var was = save ? '<s>' + esc(money(p.sep)) + '</s>' : (off ? '<s>' + esc(money(p.ca)) + '</s>' : '');
      // Cada producto es un enlace directo a su ficha.
      li.innerHTML = '<a class="zr-hanger ' + (shelf ? 'zr-hanger--shelf' : (p.flat ? 'zr-hanger--flat' : 'zr-hanger--photo')) + '" href="' + esc(p.u) + '" draggable="false" aria-label="' + esc(p.t) + ', ' + esc(price) + (save ? ', ahorras ' + esc(money(save)) : '') + (shelf ? '. Ver el producto' : '. Ver la prenda') + '">' +
        '<span class="zr-swing">' + (shelf ? '' : HOOK) +
        '<span class="zr-frame"><img class="zr-card" loading="' + (i < 4 ? 'eager' : 'lazy') + '" decoding="async" draggable="false" alt="" src="' + esc(sized(src, 600)) + '" srcset="' + esc(sized(src, 360)) + ' 360w, ' + esc(sized(src, 600)) + ' 600w" sizes="(min-width: 990px) 18vw, 46vw">' + badge +
        (!p.a ? '<span class="zr-badge zr-badge--out">Agotado</span>' : '') + '</span>' +
        '</span>' +
        '<span class="zr-meta"><span class="zr-meta__name">' + esc(shortName(p.t)) + '</span>' +
        '<span class="zr-meta__price"><b>' + esc(price) + '</b>' + was + '</span></span>' +
        '</a>';
      li.firstChild.addEventListener('click', function () {
        try { sessionStorage.setItem('zr:back', location.pathname + '|' + handle + '|' + i); } catch (e) {}
      });
      self.track.appendChild(li);
    });
    var allShelf = list.length > 0 && shelfCount === list.length;
    this.el.classList.toggle('zr--shelf', allShelf);
    this.items = Array.prototype.slice.call(this.track.children);
    var count = this.el.querySelector('[data-zr-count]');
    if (count) count.textContent = shelfCount ? list.length + ' productos' : list.length + ' prendas colgadas';
    // Al volver de una ficha, el perchero se queda en el producto que se tocó.
    var back = null;
    try { back = (sessionStorage.getItem('zr:back') || '').split('|'); } catch (e) {}
    var start = back && back[0] === location.pathname && back[1] === handle ? Math.min(Number(back[2]) || 0, list.length - 1) : 0;
    this.track.scrollLeft = 0;
    this.select(start, start > 0);
    if (!reduce.matches) {
      this.items.slice(0, 6).forEach(function (it, i) {
        var sw = it.querySelector('.zr-swing');
        if (!sw.animate) return;
        if (it.classList.contains('zr-item--shelf')) {
          sw.animate([{ transform: 'translateY(14px)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 420, delay: i * 60, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' });
        } else {
          sw.animate([
            { transform: 'translateY(-26px) rotate(-8deg)', opacity: 0 },
            { transform: 'translateY(0) rotate(3deg)', opacity: 1, offset: .65 },
            { transform: 'none', opacity: 1 }
          ], { duration: 620, delay: i * 70, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' });
        }
      });
    }
  };

  Rack.prototype.bindTrack = function () {
    var self = this, t = this.track, frame = 0, idle = 0, lastX = 0, lastT = 0;
    function paint() {
      frame = 0;
      var mid = t.scrollLeft + t.clientWidth / 2;
      var now = performance.now();
      var v = (t.scrollLeft - lastX) / Math.max(16, now - lastT);
      var r = reduce.matches ? 0 : Math.max(-8, Math.min(8, -v * 5));
      lastX = t.scrollLeft; lastT = now;
      self.items.forEach(function (it) {
        var d = Math.min(1, Math.abs(it.offsetLeft + it.offsetWidth / 2 - mid) / (it.offsetWidth * 1.4));
        it.style.setProperty('--zr-s', (1 - 0.2 * d).toFixed(3));
        it.style.setProperty('--zr-o', (1 - 0.45 * d).toFixed(3));
        it.style.setProperty('--zr-r', r.toFixed(2) + 'deg');
      });
    }
    t.addEventListener('scroll', function () {
      if (!frame) frame = requestAnimationFrame(paint);
      clearTimeout(idle);
      idle = setTimeout(function () {
        self.items.forEach(function (it) { it.style.setProperty('--zr-r', '0deg'); });
        if (self.programmatic) { self.programmatic = false; return; }
        var mid = t.scrollLeft + t.clientWidth / 2, best = 0, bd = Infinity;
        self.items.forEach(function (it, i) {
          var d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - mid);
          if (d < bd) { bd = d; best = i; }
        });
        if (best !== self.index) self.select(best, false);
      }, 140);
    }, { passive: true });
    t.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      self.select(self.index + (e.key === 'ArrowRight' ? 1 : -1), true);
      var b = self.items[self.index] && self.items[self.index].querySelector('a');
      if (b) b.focus({ preventScroll: true });
    });
    this.paint = paint;
  };

  Rack.prototype.select = function (i, scroll) {
    if (!this.items.length) return;
    i = Math.max(0, Math.min(this.items.length - 1, i));
    this.index = i;
    this.items.forEach(function (it, n) { it.classList.toggle('is-selected', n === i); });
    var p = this.products[i];
    var save = p.set && p.sep > p.p ? p.sep - p.p : 0;
    this.el.querySelector('[data-zr-name]').textContent = p.t;
    this.el.querySelector('[data-zr-price]').textContent = (p.v ? 'Desde ' : '') + money(p.p) + (save ? ' · ahorras ' + money(save) : '');
    var openBtn = this.el.querySelector('[data-zr-open]');
    if (openBtn) openBtn.textContent = isShelf(p) ? 'Ver producto' : 'Ver prenda';
    this.el.querySelector('[data-zr-step="-1"]').disabled = i === 0;
    this.el.querySelector('[data-zr-step="1"]').disabled = i === this.items.length - 1;
    if (scroll) {
      var it = this.items[i];
      this.programmatic = true;
      this.track.scrollTo({ left: it.offsetLeft - (this.track.clientWidth - it.offsetWidth) / 2, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    if (this.paint) requestAnimationFrame(this.paint);
  };

  /* ---------- Ficha rápida ---------- */
  Rack.prototype.bindQuick = function () {
    var self = this, d = this.quick;
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-zr-close]')) d.close();
    });
    d.querySelector('[data-zr-q-add]').addEventListener('click', function () { self.add(); });
    var g = d.querySelector('[data-zr-gallery]');
    g.addEventListener('scroll', function () {
      var n = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
      d.querySelectorAll('[data-zr-dots] span').forEach(function (s, i) { s.classList.toggle('is-on', i === n); });
    }, { passive: true });
    d.addEventListener('close', function () { document.documentElement.classList.remove('za-sheet-open'); });
  };

  Rack.prototype.open = function (i) {
    var p = this.products[i];
    if (!p) return;
    var d = this.quick, self = this;
    this.qp = p;
    this.sel = {};
    p.options.forEach(function (o, n) { if (o.values.length === 1) self.sel[n] = o.values[0]; });
    var g = d.querySelector('[data-zr-gallery]');
    var imgs = p.images.slice(0, 8);
    g.innerHTML = imgs.map(function (im, n) {
      return '<img src="' + esc(sized(im.src, 720)) + '" srcset="' + esc(sized(im.src, 480)) + ' 480w, ' + esc(sized(im.src, 720)) + ' 720w, ' + esc(sized(im.src, 1000)) + ' 1000w" sizes="(min-width: 990px) 440px, 100vw" alt="' + esc(n === 0 ? p.title : '') + '" loading="' + (n === 0 ? 'eager' : 'lazy') + '">';
    }).join('');
    g.scrollLeft = 0;
    d.querySelector('[data-zr-dots]').innerHTML = imgs.length > 1 ? imgs.map(function (_, n) { return '<span' + (n === 0 ? ' class="is-on"' : '') + '></span>'; }).join('') : '';
    d.querySelector('[data-zr-q-kicker]').textContent = isSet(p) ? 'Conjunto · 2 prendas' : (p.product_type || 'Prenda ZOMKI');
    d.querySelector('[data-zr-q-title]').textContent = p.title;
    var link = d.querySelector('[data-zr-q-link]');
    link.href = ROOT + 'products/' + p.handle;
    link.textContent = isSet(p) ? 'Ver el look completo en el armario' : 'Ver ficha completa y guía de tallas';
    d.querySelector('[data-zr-done]').hidden = true;
    d.querySelector('[data-zr-q-add]').hidden = false;
    d.querySelector('[data-zr-q-error]').textContent = '';
    this.renderOptions();
    document.documentElement.classList.add('za-sheet-open');
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    var close = d.querySelector('.zr-quick__close');
    if (close) close.focus();
  };

  Rack.prototype.variant = function () {
    var p = this.qp, sel = this.sel;
    if (p.options.some(function (o, n) { return !sel[n]; })) return null;
    return p.variants.filter(function (v) {
      return p.options.every(function (o, n) { return v['option' + (n + 1)] === sel[n]; });
    })[0] || null;
  };

  Rack.prototype.renderOptions = function () {
    var self = this, p = this.qp, d = this.quick;
    var box = d.querySelector('[data-zr-q-options]');
    box.innerHTML = '';
    p.options.forEach(function (o, n) {
      if (o.values.length < 2) return;
      var fs = document.createElement('fieldset');
      fs.className = 'zr-opt';
      fs.innerHTML = '<legend>' + esc(o.name) + (self.sel[n] ? ': <b>' + esc(self.sel[n]) + '</b>' : '') + '</legend><div class="zr-chips" role="radiogroup" aria-label="' + esc(o.name) + '"></div>';
      var chips = fs.querySelector('.zr-chips');
      o.values.forEach(function (val) {
        var ok = p.variants.some(function (v) {
          if (v['option' + (n + 1)] !== val || !v.available) return false;
          return p.options.every(function (o2, m) { return m === n || !self.sel[m] || v['option' + (m + 1)] === self.sel[m]; });
        });
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'zr-chip';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', String(self.sel[n] === val));
        b.textContent = val;
        if (!ok) { b.setAttribute('aria-disabled', 'true'); b.setAttribute('aria-label', val + ', agotada'); }
        b.addEventListener('click', function () {
          if (!ok) { d.querySelector('[data-zr-q-error]').textContent = val + ' está agotada en esta combinación. Elige otra opción.'; return; }
          self.sel[n] = val;
          d.querySelector('[data-zr-q-error]').textContent = '';
          self.renderOptions();
          var again = box.querySelectorAll('.zr-opt')[Array.prototype.indexOf.call(box.children, fs)];
          var c = box.querySelector('[aria-checked="true"][role="radio"]');
          if (c && again) c.focus();
        });
        chips.appendChild(b);
      });
      box.appendChild(fs);
    });
    var v = this.variant();
    d.querySelector('[data-zr-q-price]').textContent = v ? money(cents(v.price)) : priceLabel(p);
    var add = d.querySelector('[data-zr-q-add]');
    add.textContent = v ? (v.available ? 'Añadir al carrito · ' + money(cents(v.price)) : 'Agotado') : 'Añadir al carrito';
    add.disabled = !!(v && !v.available);
  };

  Rack.prototype.add = function () {
    var self = this, d = this.quick, p = this.qp, err = d.querySelector('[data-zr-q-error]');
    var missing = p.options.filter(function (o, n) { return !self.sel[n]; }).map(function (o) { return o.name.toLowerCase(); });
    if (missing.length) { err.textContent = 'Elige ' + missing.join(' y ') + '.'; return; }
    var v = this.variant();
    if (!v || !v.available) { err.textContent = 'Esta opción está agotada. Prueba con otra.'; return; }
    var btn = d.querySelector('[data-zr-q-add]');
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'No hemos podido añadirlo.'); return j; });
    }).then(function () {
      btn.hidden = true;
      d.querySelector('[data-zr-done]').hidden = false;
      d.querySelector('[data-zr-done-text]').textContent = p.title + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '') + ' · ' + money(cents(v.price));
      d.querySelector('[data-zr-done-title]').focus();
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-bubble__text-count, [data-zomki-field="count"]').forEach(function (el) {
          el.textContent = cart.item_count; el.classList.toggle('hidden', cart.item_count === 0);
        });
        document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', cart.item_count === 0); });
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'zomki-percheros', data: { source: 'zomki-percheros', itemCount: cart.item_count } } }));
      });
    }).catch(function (e) { err.textContent = e.message; })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        self.renderOptions();
      });
  };

  function init() {
    document.querySelectorAll('[data-zr]').forEach(function (el) { if (!el.__zr) el.__zr = new Rack(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
